<isophi-info-popup
  *transloco="let t"
  [title]="t('childrenPortfolio/dashboard/popup/title')"
  [continueLabel]="t('childrenPortfolio/dashboard/popup/continue')"
  [(dontShowAgain)]="dontShowAgain"
  (closed)="close()"
>
  <img src="../../../../../assets/img/child-portfolio-dashboard/ship.jpg" alt="" />
  <div class="text-wrapper">
    <div [innerHTML]="t('childrenPortfolio/dashboard/popup/text1')"></div>
    <div [innerHTML]="t('childrenPortfolio/dashboard/popup/text2')"></div>
    <div [innerHTML]="t('childrenPortfolio/dashboard/popup/text3')"></div>
    <div [innerHTML]="t('childrenPortfolio/dashboard/popup/text4')"></div>
    <div [innerHTML]="t('shared/popup/contact')"></div>
  </div>
</isophi-info-popup>
